var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 25 25",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5001 13.5217L12.7278 16.9039C13.1557 17.2462 13.7794 17.1804 14.1264 16.7562L22.5001 6.52173",
    stroke: "#315CD5",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#315CD5",
    strokeWidth: 0.2,
    stroke: "#315CD5",
    clipRule: "evenodd",
    d: "M11.6892 12.7585L16.274 7.155C16.6237 6.72755 16.5607 6.09753 16.1332 5.7478C15.7058 5.39807 15.0758 5.46108 14.726 5.88852L10.1527 11.4781L11.6892 12.7585ZM8.52292 16.6285L6.98642 15.3481L6.33309 16.1466L3.1 13.7218C2.65817 13.3904 2.03137 13.4799 1.7 13.9218C1.36863 14.3636 1.45817 14.9904 1.9 15.3218L5.13309 17.7466C5.99047 18.3896 7.20234 18.2425 7.881 17.4131L8.52292 16.6285Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.c32371ced753feb17be8d3281e5983c9.svg";
export { ForwardRef as ReactComponent };